/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { aiConfigsUpdateVariation } from "../../funcs/aiConfigsUpdateVariation.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PatchAIConfigVariationRequest$inboundSchema,
};

export const tool$aiConfigsUpdateVariation: ToolDefinition<typeof args> = {
  name: "update-ai-config-variation",
  description:
    `Updates a specific variation within an AI Config. Enables fine-tuned control of model behavior.
`,
  scopes: ["write"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await aiConfigsUpdateVariation(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
